import { QueryClientProvider } from "@tanstack/react-query";
import { createRootRoute, HeadContent, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Toaster, TooltipProvider } from "@h2j-data-team/ui";

import { queryClient } from "@/lib/query-client";
import { NotFoundScreen, RouteErrorComponent } from "@/components/error-screen";

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: RouteErrorComponent,
  notFoundComponent: NotFoundScreen,
});

function RootComponent() {
  const { t } = useTranslation("common");
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <HeadContent />
        <Outlet />
        <Toaster
          position="top-center"
          closeButton
          duration={4000}
          labels={{ region: t("toaster.region"), close: t("close") }}
        />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
